var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiversityCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H2V1H18V5M18 5C19.3261 5 20.5979 5.52678 21.5355 6.46447C22.4732 7.40215 23 8.67392 23 10C23 11.3261 22.4732 12.5979 21.5355 13.5355C20.5979 14.4732 19.3261 15 18 15C16.6739 15 15.4021 14.4732 14.4645 13.5355C13.5268 12.5979 13 11.3261 13 10C13 8.67392 13.5268 7.40215 14.4645 6.46447C15.4021 5.52678 16.6739 5 18 5ZM15 14V22L18 20L21 22V14M5 8H11M5 11H10M5 14H7M5 5H7",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversityCertificate);
export default __webpack_public_path__ + "static/media/diversityCertificate.3eed175a3b97f37e0f056141703b1ce1.svg";
export { ForwardRef as ReactComponent };